import type { HelpFile } from '../../types/help'
import { ScriptEditorPageTestIds } from '../../../testids/ScriptEditorPageTestIds'

export const scriptEditorPageHelp: HelpFile = {
  docPage: '/docs/connectors/script-editor',
  texts: {
    [ScriptEditorPageTestIds.scriptEditorPage]:
      'In-app editor for writing and saving connector scripts, with syntax highlighting and conflict detection on save.',
    [ScriptEditorPageTestIds.editorToolbar]: null,
    [ScriptEditorPageTestIds.badgeUnsaved]: null,
    [ScriptEditorPageTestIds.btnBack]: null,
    [ScriptEditorPageTestIds.btnBackError]: null,
    [ScriptEditorPageTestIds.btnBackTaskNotFound]: null,
    [ScriptEditorPageTestIds.btnCancelDiscard]: null,
    [ScriptEditorPageTestIds.btnConfirmDiscard]:
      'Discard unsaved changes and leave the editor — this cannot be undone.',
    [ScriptEditorPageTestIds.btnConflictCancel]: null,
    [ScriptEditorPageTestIds.btnConflictReload]:
      'Reload the latest server version of the script, discarding your unsaved changes.',
    [ScriptEditorPageTestIds.btnSave]:
      'Save the script; detects concurrent edits and surfaces a conflict resolution prompt when needed.',
    [ScriptEditorPageTestIds.editorError]: null,
    [ScriptEditorPageTestIds.editorLoading]: null,
    [ScriptEditorPageTestIds.editorTaskNotFound]:
      'The task referenced by this script no longer exists — it may have been removed.',
  },
}
